import TextTitleCompressedHeavyUpperCase from 'components/TextTitleCompressedHeavyUpperCase.js'
import TextTitleCompressedLight from 'components/TextTitleCompressedLight.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'

const messages = defineMessages({
  gymaholic: {
    id: 'Training.gymaholic',
    defaultMessage: 'Gymaholic'
  },
  fitnessApp: {
    id: 'Training.fitnessApp',
    defaultMessage: 'App'
  }
})

export default function GymaholicFitnessAppTitle () {
  const intl = useIntl()
  return (
    <>
      <TextTitleCompressedHeavyUpperCase>
        {formatMessageIntlUtil(intl, messages.gymaholic)}
      </TextTitleCompressedHeavyUpperCase>
      <TextTitleCompressedLight ml>
        {formatMessageIntlUtil(intl, messages.fitnessApp)}
      </TextTitleCompressedLight>
    </>
  )
}
